import date from './methods'

export default (ctx, inject) => {
  ctx.$date = date
  inject('date', date)
}
